import { ChargebeePlan, PlanType, UserSubscription } from 'enums/user-plan';

const TWO_YEARS_BEFORE_NOW = new Date(new Date().setFullYear(new Date().getFullYear() - 2));
const TEN_YEARS_BEFORE_NOW = new Date(new Date().setFullYear(new Date().getFullYear() - 10));

const useGetPlansData = (prices, registrationDateString = null) => {
  const getPlanInfo = (planName, period, isPrice) => {
    const findPlan = (plan) => plan?.name === planName;
    const findMonthPeriod = (billing) => billing?.periodUnit === period;
    const selectedPlan = prices?.find(findPlan)?.billings?.find(findMonthPeriod);
    return isPrice ? selectedPlan?.price.toString().slice(0, -2) : selectedPlan?.id;
  };
  const getDiscountPrice = (planName, period) => {
    const findPlan = (plan) => plan?.name === planName;
    const findMonthPeriod = (billing) => billing?.periodUnit === period;
    const selectedPlan = prices?.find(findPlan)?.billings?.find(findMonthPeriod);
    return selectedPlan?.discountedPrice?.toString().slice(0, -2);
  };

  const registrationDate = new Date(registrationDateString);

  const plansContent = [
    {
      name: 'Free',
      plan: PlanType.free,
      header: 'Basic credit profile.',
      recommendedLabel: '',
      isRecommendedPlan: false,
      description: 'A good place to start understanding your company credit profile.',
      monthly: 0,
      yearly: 0,
    },
    {
      name: 'Startup',
      plan: PlanType.startup,
      header: 'Available for companies under 2 years only.',
      recommendedLabel: 'Recommended for startups',
      isRecommendedPlan: registrationDate.getTime() >= TWO_YEARS_BEFORE_NOW.getTime(),
      description:
        'Great for early stage businesses. See your full Experian credit report as banks and lenders see it',
      monthly: getPlanInfo(ChargebeePlan.smeStartup, UserSubscription.month, true),
      yearly: getPlanInfo(ChargebeePlan.smeStartup, UserSubscription.year, true),
      discountedMonthly: getDiscountPrice(ChargebeePlan.smeStartup, UserSubscription.month),
      discountedYearly: getDiscountPrice(ChargebeePlan.smeStartup, UserSubscription.year),
      planIdMonthly: getPlanInfo(ChargebeePlan.smeStartup, UserSubscription.month, false),
      planIdYearly: getPlanInfo(ChargebeePlan.smeStartup, UserSubscription.year, false),
    },
    {
      name: 'Pro',
      plan: PlanType.pro,
      header: 'Your full credit profile plus 10 credit checks.',
      recommendedLabel: 'Best value',
      isRecommendedPlan:
        (registrationDate.getTime() < TWO_YEARS_BEFORE_NOW.getTime() &&
          registrationDate.getTime() >= TEN_YEARS_BEFORE_NOW.getTime()) ||
        registrationDateString === undefined,
      description:
        'A must have for all UK companies. See your full credit file and monitor risks to customers.',
      monthly: getPlanInfo(ChargebeePlan.smePro, UserSubscription.month, true),
      discountedMonthly: getDiscountPrice(ChargebeePlan.smePro, UserSubscription.month),
      discountedYearly: getDiscountPrice(ChargebeePlan.smePro, UserSubscription.year),
      yearly: getPlanInfo(ChargebeePlan.smePro, UserSubscription.year, true),
      planIdMonthly: getPlanInfo(ChargebeePlan.smePro, UserSubscription.month, false),
      planIdYearly: getPlanInfo(ChargebeePlan.smePro, UserSubscription.year, false),
    },
    {
      name: 'Enterprise',
      plan: PlanType.enterprise,
      header: 'Your full credit profile plus 100 credit checks.',
      recommendedLabel: 'Recommended',
      isRecommendedPlan: registrationDate.getTime() < TEN_YEARS_BEFORE_NOW.getTime(),
      description: 'Ideal for finance and compliance teams looking for a risk management tool.',
      monthly: getPlanInfo(ChargebeePlan.smeEnterprise, UserSubscription.month, true),
      yearly: getPlanInfo(ChargebeePlan.smeEnterprise, UserSubscription.year, true),
      discountedMonthly: getDiscountPrice(ChargebeePlan.smeEnterprise, UserSubscription.month),
      discountedYearly: getDiscountPrice(ChargebeePlan.smeEnterprise, UserSubscription.year),
      planIdMonthly: getPlanInfo(ChargebeePlan.smeEnterprise, UserSubscription.month, false),
      planIdYearly: getPlanInfo(ChargebeePlan.smeEnterprise, UserSubscription.year, false),
    },
  ];

  return plansContent;
};

export default useGetPlansData;
